import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { postOrganization } from '../../../api/organizations';

import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';

import { REQUEST } from '../../../constants/request';

export const createOrganization = createAsyncThunk(
  'organizations/createOrganization',
  async ({ body, params }, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const response = await postOrganization(
        { body, params },
        {
          cancelToken: source.token,
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
  {
    condition({ body: { id } }, { getState }) {
      const { organizations } = getState().organizations;

      return (
        organizations.organization.actions.create.request[id]?.loading !==
        REQUEST.pending
      );
    },
  },
);

export const createOrganizationExtraReducers = builder => {
  builder
    .addCase(createOrganization.pending, (state, action) => {
      const organizationId = action.meta.arg.body.id;
      checkAndSetLoadingWithId(
        state.organizations.organization.actions.create.request,
        action,
        organizationId,
      );
    })
    .addCase(createOrganization.fulfilled, (state, action) => {
      const organizationId = action.meta.arg.body.id;
      onMatchedRequest(
        state.organizations.organization.actions.create.request[organizationId],
        action,
        () => {
          state.organizations.organization.byId[organizationId] =
            action.payload;
          state.organizations.organization.allIds.push(organizationId);
        },
      );
    })
    .addCase(createOrganization.rejected, (state, action) => {
      const organizationId = action.meta.arg.body.id;
      handleRequestRejection(
        state.organizations.organization.actions.create.request[organizationId],
        action,
      );
    });
};
